import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { Cabeceracorporativo } from "./cabeceracorporativo.component";
import {FormsModule} from '@angular/forms';
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { TimerModule } from "../timer/timer.module";


@NgModule({
    declarations: [Cabeceracorporativo],
    imports: [BrowserModule, RouterModule, FormsModule, TimerModule],
    exports:[Cabeceracorporativo],
    providers:[DatosGeneralesService]
})

export class CabeceracorporativoModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceracorporativo/cabeceracorporativo.module.ts